export default __webpack_public_path__ + "static/media/blinkIcon.e15a6069.svg";